<template>
  <div class="small_video_page" :style="{'height': contentHeight + 'px'}">
    <div class="top_banner">
      <img class="top_logo" src="../../assets/tfsharelogo.png" alt="">
      <div class="middel-info">
        <div>铁粉生活</div>
        <div class="s_text">湖南广电旗下唯一本地生活服务APP</div>
      </div>
      <div id="btn_open">打开APP</div>
    </div>
    <div style="margin-top: 55px;" class="main_container" v-if="!isEmpty">
      <div class="video_container">
        <div style="flex: 1">
          <video :src="info.videoUrl" autoplay controls style="width: 100%"></video>
        </div>
      </div>
      <div class="video_info">
        {{ info.title }}
        <div class="content" v-html="info.textContent"></div>
      </div>
      <div class="num_info">
        <Icon type="md-heart-outline" size="26" />
        <div>{{ info.praiseNum | numFormat }}</div>
        <Icon type="md-text" size="26" />
        <div>{{ info.commentNum | numFormat }}</div>
      </div>
    </div>
    <div v-else class="empty_container" :style="{'height': contentHeight + 'px'}">视频已被删除</div>
    <Spin fix size="large" v-if="loading"></Spin>
  </div>
</template>
<script>
import moment from 'moment'
export default {
  name: "articlePage",
  components: {},
  data() {
    return {
      loading: true,
      isEmpty: false,
      drawerShow: false,
      mIndex: 0,
      mx0: 0,
      mx1: 0,
      info: {},
      commentList: [],
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      replyPageIndex: 1,
      replyPageSize: 20,
      commentInfo: {
        children: []
      },
      contentHeight: document.documentElement.clientHeight,
    };
  },
  filters: {
    dateFormat: function (value) {
      if (!value) return ''
      return moment(value).format('YYYY-MM-DD')
    },
    timeFormat: function (value) {
      if (!value) return ''
      return moment(value).format('YYYY-MM-DD HH:mm:ss')
    },
    numFormat: function (value) {
      if (value > 10000) {
        return (value / 10000).toFixed(1) + '万'
      }
      return value
    }
  },
  mounted() {
    let param = this.$route.query
    this.lifeId = param.id

    // 铁粉生活短视频 linkType(17:短视频)
    var data = XInstall.parseUrlParams();
    new XInstall({
      appKey : "mq81ipn",
      buttonId: [
        { idName: 'btn_open', params: {linkType: 17, linkId: param.id} }
      ]
    }, data);

    this.getLifeInfo()
  },
  methods: {
    getLifeInfo() {
      let that = this
      that.loading = true
      this.$http.get('/appTflifenInfo/open/getLifeDetail', {
        lifeId: this.lifeId
      }, function (data) {
        that.info = data.data
        if (that.info.images) {
          that.info.playImagesUrl = that.info.images.split(',')
        } else {
          that.info.playImagesUrl = []
        }
        that.info.textContent = that.info.textContent.replace(/\r\n/g, '<br>').replace(/\n/g, '<br>')
        that.isEmpty = false
        that.loading = false
      }, function () {
        that.isEmpty = true
        that.info.playImagesUrl = []
        that.loading = false
      })
    },
  }
};
</script>
<style scoped>
.small_video_page {
  background: #333;
  position: relative;
  overflow-y: auto;
  color: #fff;
}
.top_banner {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 99;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 500;
  background: rgb(255, 255, 255);
  padding: 6px;
  color: #000;
  border-bottom: 1px solid #eee;
}
.top_logo {
  width: 40px;
  border-radius: 6px;
}
.middel-info {
  flex: 1;
  margin-left: 6px;
  font-size: 16px;
}
.s_text {
  font-size: 12px;
  color: rgba(153,153,153,1);
}
#btn_open {
  background-color: #3C74F2;
  padding: 5px 10px;
  font-size: 12px;
  border-radius: 20px;
  color: #fff;
}
.main_container {
  height: calc(100% - 65px);
  width: 100%;
  position: relative;
}
.video_container {
  height: calc(100% - 120px);
  display: flex;
  align-items: center;
}
.video_info {
  padding: 10px;
  font-size: 16px;
  height: 120px;
  overflow-y: auto;
}
.content {
  font-size: 12px;
  color: #f5f5f5;
}
.num_info {
  position: absolute;
  bottom: 100px;
  right: 10px;
  width: 70px;
  text-align: center;
}
.empty_container {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/smallvideo.vue